import { render } from "./BaseConfig.vue?vue&type=template&id=483b69b6&scoped=true"
import script from "./BaseConfig.vue?vue&type=script&lang=js"
export * from "./BaseConfig.vue?vue&type=script&lang=js"

import "./BaseConfig.vue?vue&type=style&index=0&id=483b69b6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483b69b6"]])

export default __exports__